import { render, staticRenderFns } from "./SupplyBase.vue?vue&type=template&id=9a37692c&scoped=true&"
import script from "./SupplyBase.vue?vue&type=script&lang=js&"
export * from "./SupplyBase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a37692c",
  null
  
)

export default component.exports